import { createApp } from 'vue'
import { createStore } from 'vuex'
import App from './App.vue'
import './styles/app.css'; // insert Tailwind css

import * as Sentry from "@sentry/vue";

import Keycloak from 'keycloak-js'
import { KeycloakSettings } from './config.js';
import i18n from './i18n'
import Loading from 'vue3-loading-screen'
import VueSimpleAlert from "vue3-simple-alert";

let keycloak = new Keycloak(KeycloakSettings);

const store = createStore({
  state: { 
    account:{password: '', firstname: '', lastname: ''}, 
    address: {country: 'Nederland'}, 
    company: {cashgap: 7980, cash_register:2050, country_code:'NL'}, 
    subscription: undefined,
    journals: [],
    accountingPaymentLedger: {}
  },
  mutations: {
    updateAccountInformation(state, values) {
      state.account[values.id] = values.value
    },
    updateCompanyInformation(state, values){
      console.debug('update company info')
      state.company[values.id] = values.value
    },
    updateAddressInformation(state, values){
      state.address[values.id] = values.value
    },
    addJournalConnection(state, connection) {
      state.journals.push(connection)
    },
    deleteJournalConnection(state, value){
      state.journals.splice(Number(value), 1);
    },
    updateDevice(state, device){
      state.device = device
    },
    accountingPaymentLedger(state, paymentLedger){
      console.log(paymentLedger)
      state.accountingPaymentLedger = paymentLedger
    },
    selectedSubscription(state, subscription){
      state.subscription = subscription
    },
    selectedCashGapLedger(state, ledger){
      state.company.cashgap = ledger
    },
    updateCashRegister(state, ledger){
      state.company.cash_register = ledger
    }
  },
}
)

const app = createApp(App)
app.provide('keycloak', keycloak)
app.use(i18n)
app.use(store)
app.use(VueSimpleAlert)
app.use(Loading, {
  bg: '#44C1FFad',
  slot: `
  <div class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-xl px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center" >
  <svg aria-hidden="true" role="status" class="inline w-12 h-12 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
    </svg>
    Loading...
</div>
  `
})

let package_version = process.env.VUE_APP_VERSION || '0'

Sentry.init({
  app,
  environment: process.env.NODE_ENV,
  release: "humbee-boording-app@" + package_version,
  dsn: "https://462eb2a3443a48b586bc686a4295b2a9@sentry.staging.octoblue.nl/5",
  maxBreadcrumbs: 50,
  trackComponents: true,
  hooks: ["mount", "update", "destroy"],
  tracesSampleRate: 0.2,
});

keycloak.init({ onLoad: 'login-required', checkLoginIframe: false }).then((auth) => {
  if (!auth) {
    window.location.reload();
  } else {
    console.info("Authenticated");
    
    app.mount('#app')
  }

  keycloak.loadUserProfile()
    .then(function(profile) {
        Sentry.setUser({ email: profile.email, id: profile.id, username: profile.username});
    });


  //Token Refresh
  setInterval(() => {
    keycloak.updateToken(70).then((refreshed) => {
      if (refreshed) {
        console.info('Token refreshed' + refreshed);
      } else {
        console.debug('Token not refreshed, valid for '
          + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
      }
    }).catch(() => {
      console.error('Failed to refresh token');
    });
  }, 30000)

}).catch((err) => {
  console.error("Error accoured", err);
  // window.location.reload();
});

export default function parse(a, b) {
  return a + b;
}
